import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetClassificationFlat from './GetMeetClassificationFlatData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  areOptionsLoaded: false,
  trackMedals: null,
  isOpenCompetition: null,
  trackCareerStats: null
};

const MeetClassificationFlatData = {
  INITIAL_STATE, getMeetClassificationFlat
};

export default MeetClassificationFlatData;